module.exports = __webpack_public_path__ + "img/img-3-4.f034cb2f.png";